export default "__VITE_ASSET__BnN546wx__"